import { useState } from "react";
import { ReactComponent as MenuIcon } from "../../assets/menu.svg";
import { ReactComponent as CloseIcon } from "../../assets/close.svg";
import navLinks from "../../constants/navLinks";
import styles from "../../constants/styles";

const NavBar = () => {
  const [active, setActive] = useState(navLinks[0].title);
  const [isOpen, setIsOpen] = useState(false);

  const handleScrollToSection = (navObject: { title: string; id: string }) => {
    const section = document.getElementById(navObject.id);
    setActive(navObject.title);
    if (section) {
      section.scrollIntoView({
        behavior: "smooth"
      });
    }
  };

  return (
    <nav>
      <div className="hidden md:flex flex-row justify-evenly space-x-8">
        {navLinks.map(nav => (
          <button
            key={nav.id}
            type="button"
            className={`${styles.quartiaryHeading} ${styles.hoverShrinkEffect} text-black hover:text-green-500`}
            onClick={() => handleScrollToSection(nav)}
          >
            {nav.title}
          </button>
        ))}
      </div>

      {/* Mobile Menu */}
      <div className="flex md:hidden justify-end">
        <svg
          className="w-10 h-10 transition"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <CloseIcon /> : <MenuIcon />}
        </svg>
      </div>

      <div
        className={
          isOpen
            ? "p-6 bg-green-500 absolute right-6 min-w-min rounded-xl"
            : "hidden"
        }
      >
        <div className="flex flex-col items-center space-y-4">
          {navLinks.map(nav => (
            <button
              key={nav.id}
              type="button"
              className={`${styles.quartiaryHeading} ${
                active === nav.title ? "text-white" : "text-dimWhite"
              }`}
              onClick={() => handleScrollToSection(nav)}
            >
              {nav.title}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
